<template>
  <div>
   <!-- 교환 상품 테이블 영역 -->
    <admin-form-item label="교환 상품" style="margin-top:12px">
      <table class="delivery-orderproduct-table">
        <thead>
        <tr>
          <!--<th style="width:5%">
            <lp-check-bool :checkedVal.sync="check" @onCheck="clickCheckBoxAll"></lp-check-bool>
          </th>-->
          <!--<th style="width:20%">상품 주문 번호</th>-->
          <th style="width:25%">주문 상품</th>
          <th style="width:10%">옵션 단가</th>
          <th style="width:5%">수량</th>
          <th style="width:5%">삭제</th>
          <!--<th style="width:10%">운송장 정보</th>-->
          <!--<th style="width:15%">주문 상태</th>-->
        </tr>
        </thead>
        <tbody>
        <tr>
          <td colspan="7">
            <button class="button is-primary" @click="$modal.show('productlistModal')" v-if="value.order_product.length===0">교환 상품 추가</button>
          </td>
        </tr>
        <tr v-for="(op,idx) in value.order_product" :key="'op-'+idx">
          <!--<td style="width:5%">
            <lp-check-bool
              v-if="checkArr[idx]!==undefined && !op.isNew"
              :checkedVal.sync="checkArr[idx].value"></lp-check-bool>
          </td>-->
          <!--<td style="width:20%">{{ op.id }}</td>-->
          <td style="width:25%">
            <div class="flex">
              <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
              <div style="text-align: left">
                <div v-if="op.order_product_option.length>0">
                  <div>{{ op.product.name }}</div>
                  <div style="color:#C1C1C1;font-size:14px"
                       v-for="(option, option_idx) in op.order_product_option"
                       :key="'option-'+option_idx">
                    <span v-if="option.option.option_type===0">기본옵션:</span>
                    <span v-if="option.option.option_type===1">추가옵션:</span>
                    {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                  </div>
                </div>
                <div v-else>
                  {{ op.product.name }} {{ op.quantity }}개
                </div>
              </div>
            </div>

          </td>
          <td style="width:10%">{{ op.op_product_price | currency }}</td>
          <td style="width:5%">{{ op.op_quantity }}</td>
          <td style="width:5%">
            <button class="button is-danger half" @click.stop.prevent="deleteProduct(idx)">삭제</button>
          </td>
        <!--  <td style="width:10%">
            <div>
              <span class="select">
                <select v-model="op.delivery_company"
                        @change="e=> selectDeliveryCompany(e, op)">
                  <option value="" disabled selected>선택</option>
                  <option :value="item.value"
                          v-for="item in deliveryArr" :key="item.label">{{ item.label }}</option>
                </select>
              </span>
            </div>
            <div>
              <input class="input"
                     :value="op.invoice"
                     @input="e => op.invoice = e.target.value"
                     placeholder="송장번호 입력"
                     type="number">
            </div>
          </td>
          <td style="width:15%">{{ op.status_kor }}</td>-->
        </tr>
        </tbody>
      </table>
    </admin-form-item>

    <!-- 일괄 처리 -->
    <div v-if="status_arr.length>0"
         class="flex-between"
         style="background-color: #eee; padding: 8px">
      <div class="flex align-center">
        <span>선택한 주문을</span>
        <span class="select" style="margin-left: 8px">
          <select v-model="status" @change="e => status=parseInt(e.target.value)">
            <option value="" disabled selected>주문상태</option>
            <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
          </select>
        </span>
        <button class="button" style="margin-left:8px"
                @click="clickChange">일괄처리</button>
      </div>
    </div>

    <!-- 상품 목록 팝업 -->
    <modal name="productlistModal"
           :adaptive="true"
           :width="900"
           height="auto"
           class="modal-style">
      <lp-order-product-create
        @addProduct="addProduct"
        @closeModal="$modal.hide('productlistModal')"></lp-order-product-create>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpOrderProductCreate from "../../../module/custom/LpOrderProductCreate";
  import OrderMixin from '@/mixins/OrderCreateMixin'

  export default {
    components: {
      LpOrderProductCreate,
      LpCheckBool},
    mixins: [
      OrderMixin
    ],
    name: "exchange-product",
    props: {
      // 교환 상품
      exchange_order_product: {
        type: Array,
        required: false
      },
      status_arr: {
        type: Array,
        required: false
      }
    },
    data () {
      return {
        check: false,
        checkArr: [],
        // 배송회사
        deliveryArr: [],
        // 교환 상품
        value: {
          order_product: []
        }
      }
    },
    created () {
      let checkArr = [];
      this.exchange_order_product.forEach(item => {
        checkArr.push({'id': item.id, 'value': false})
      })
      this.getDeliveryCompany();
      this.value.order_product = this.exchange_order_product;
    },
    watch: {
      exchange_order_product (n) {
        this.value.order_product = n;
      },
    },
    computed: {
      /*calcQuantity () {
        let quantity = 0;
        this.exchange_order_product.forEach(item => {
          quantity += item.quantity;
        })
        return quantity
      },
      calcDiscountPrice () {
        let discount_price = 0;
        this.exchange_order_product.forEach(item => {
          discount_price += item.discount_price;
        })
        return discount_price
      }*/
    },
    methods: {
      deleteProduct(idx) {
        removeIndex(this.value.order_product,idx);
      },
      addProduct(value){
        let order_product = this.cloneItem(this.value.order_product.concat(value));
        order_product.forEach(item=> {
          item.selected=true;
        })
        this.value.order_product = order_product;
        this.initialize();
        this.$emit('update:exchange_order_product', order_product);
        this.$modal.hide('productlistModal');
      },
      clickCheckBoxAll () {

      },
      clickChange () {

      },
      getDeliveryCompany() {
        this.$axios.get('public/delivery/delivery_company').then(res=> {
          this.deliveryArr = res.data;
        })
      },
      selectDeliveryCompany(e, op) {
        op.delivery_company = e.target.value;
        this.$axios.post(this.getUrl(`delivery/orderproduct/${op.id}/invoice/update`), {
          invoice: op.invoice,
          delivery_company: op.delivery_company
        }).then(()=> {})
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
  .delivery-refund-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

  .delivery-refund-info td
    text-align left
    border 1px solid #e0d9d9
    padding 10px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
  .delivery-refund-info .order-info-title
    background-color #eee
</style>
